const Title = () => {
  const oneIntendation = ' ';
  return (
    <>
      <h1 className="stockwiz-landing__container__title">
        Unleash the Power of
        <br />
        <span>Automated Trading</span>
      </h1>

      <p className="stockwiz-landing__container__sub-title">
        Unleash the power of fully automatic{oneIntendation}
        <br className="d-md-none" />
        systematic trading, to{oneIntendation}
        <br className="d-none d-sm-block" />
        change your trading {oneIntendation}
        <br className="d-md-none" />
        game forever.
      </p>
    </>
  );
};

export default Title;
